export const opcoesPrioridade = {
  TODAS_FICHAS: 'TODAS_FICHAS',
  PREFERENCIA_ANALISE_DOCUMENTOS: 'PREFERENCIA_ANALISE_DOCUMENTOS',
  EXCLUSIVO_ANALISE_DOCUMENTOS: 'EXCLUSIVO_ANALISE_DOCUMENTOS'
}

export const opcoesPrioridadeOptions = [
  {
    value: 'TODAS_FICHAS',
    label: 'Todas as Fichas'
  },
  {
    value: 'PREFERENCIA_ANALISE_DOCUMENTOS',
    label: 'Preferência de Análise de Documentos'
  },
  {
    value: 'EXCLUSIVO_ANALISE_DOCUMENTOS',
    label: 'Exclusivo Análise de Documentos'
  }
]
